// extracted by mini-css-extract-plugin
export var divider = "_u2-0";